//client side redirect
$('form[data-form-search]').submit(function (e) {

    var searchTargetUrl = $(this).attr("data-form-search-target");

    var searchQueryPrependHash = $(this).attr("data-form-search-prepend-hash");

    var serializedInput = $(this).find('*').not('[data-form-exclude]').serialize();

    //console.log("form submitted with serailized input:");
    //console.log(serializedInput);

    var search = window.location.search;

    //if there is not a search target, its /, or the current page, updated query string, which can then be hooked into as an event for ajax refreshes by other components

    // Get the hash portion of the URL
    const hashParams = window.location.hash ? window.location.hash.substring(1) : '';

    // Construct the base URL by removing both query strings and hash parameters
    const baseUrl = window.location.href.replace(window.location.search, '').replace(window.location.hash, '');

    // If there is no search target, it's `/`, or matches the base URL, update the query/hash string
    if (!searchTargetUrl || searchTargetUrl === '/' || searchTargetUrl === baseUrl) {
        changeQueryString(serializedInput);

        // Close search modal
        $('#headerSearchModal').modal('hide');
    }

    //otherwise, redirect to search target
    else if (searchTargetUrl) {

        if (searchQueryPrependHash) {
            window.location.href = searchTargetUrl + "#" + searchQueryPrependHash + '&' + serializedInput;
        }
        else {
            window.location.href = searchTargetUrl + '?' + serializedInput;
        }

    }
});

function changeQueryString(queryString) {
    var newUrl = window.location.href.split(/[?#]/)[0] + "?" + queryString;
    window.history.pushState({ path: newUrl }, '', newUrl);
}
